import type { tGenerateAtlasFileArgs, tGenerateAtlasFileOutput } from "./types";
import type { tPhaserAtlas, tPhaserAtlasFrame } from "./types";

export const generatePhaserAtlasFile = ({
  baseFileName,
  fileNamePostfix,
  packedSprites,
  textureWidth,
  textureHeight,
  textureAtlasFilename,
  spritesMap,
  pixelFormat,
}: tGenerateAtlasFileArgs): tGenerateAtlasFileOutput => {
  const atlas: tPhaserAtlas = {
    textures: [
      {
        image: textureAtlasFilename,
        ...(pixelFormat && { format: pixelFormat }),
        size: {
          w: textureWidth,
          h: textureHeight,
        },
        scale: 1,
        frames: packedSprites.reduce((acc, packedSprite) => {
          const sprite = spritesMap[packedSprite.id];
          if (!sprite) return acc;
          const { width, height } = sprite;
          acc.push({
            filename: sprite.name,
            frame: {
              x: packedSprite.x,
              y: packedSprite.y,
              w: width,
              h: height,
            },
            sourceSize: { w: width, h: height },
            spriteSourceSize: { x: 0, y: 0, w: width, h: height },
            trimmed: false,
            rotated: Boolean(packedSprite.rotated),
          });
          return acc;
        }, [] as tPhaserAtlasFrame[]),
      },
    ],
  };
  return {
    entries: [
      {
        fileName: `${baseFileName}${fileNamePostfix}.json`,
        content: JSON.stringify(atlas, null, 2),
      },
    ],
  };
};
